<div *ngIf="userService.currentUser$ | async; let currentUserProfile">
  <div class="user-profile-container">
    <div class="profile-header mb-4">
      <div class="flex align-items-center">
        <div class="profile-avatar mr-3">
          <i class="pi pi-user text-white text-2xl"></i>
        </div>
        <div>
          <h3 class="text-xl font-semibold text-900 m-0">
            {{ currentUserProfile.first_name }} {{ currentUserProfile.last_name }}
          </h3>
          <p class="text-600 m-0">{{ currentUserProfile.username }}</p>
        </div>
      </div>
    </div>

    <div class="profile-details mb-4">
      <div class="grid">
        <div class="col-12 md:col-6">
          <div class="detail-item">
            <label class="text-600 font-medium">First Name</label>
            <p class="text-900 font-semibold">
              {{ currentUserProfile.first_name || 'Not provided' }}
            </p>
          </div>
        </div>
        <div class="col-12 md:col-6">
          <div class="detail-item">
            <label class="text-600 font-medium">Last Name</label>
            <p class="text-900 font-semibold">
              {{ currentUserProfile.last_name || 'Not provided' }}
            </p>
          </div>
        </div>
        <div class="col-12 md:col-6">
          <div class="detail-item">
            <label class="text-600 font-medium">Username</label>
            <p class="text-900 font-semibold">
              {{ currentUserProfile.username || 'Not provided' }}
            </p>
          </div>
        </div>
        <div class="col-12 md:col-6">
          <div class="detail-item">
            <label class="text-600 font-medium">Email</label>
            <p class="text-900 font-semibold">{{ currentUserProfile.email || 'Not provided' }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="profile-actions">
      <div class="flex gap-2 mb-3">
        <p-button
          label="Edit Profile"
          icon="pi pi-pencil"
          styleClass="p-button-outlined"
          (onClick)="openEditUserProfileDialog()"
        ></p-button>
        <p-button
          label="Change Password"
          icon="pi pi-lock"
          styleClass="p-button-outlined"
          (onClick)="togglePasswordReset()"
        ></p-button>
      </div>

      <div *ngIf="showPasswordReset" class="password-reset-section">
        <p-divider></p-divider>
        <div class="mt-3">
          <app-password-reset></app-password-reset>
        </div>
      </div>
    </div>
  </div>
</div>
